export default {

	data() {
		return {

			OBJECT_DEFAULTS: {
				angle: 0,               // Angle of object (center pivot)
				flipX: false,           // Flip on X axis?
				flipY: false,           // Flip on Y axis?
				stroke: '#000000',      // Border color
				fill: '',               // Fill color
				strokeWidth: 10,        // Border thickness
				width: 100,             // Shape width
				height: 100             // Shape height
			},

			TEXT_DEFAULTS: {
				fontSize: 1,            // Font size
				fontFamily: 'Arial',    // Font
				fontStyle: 'normal',    // "italic" or "normal"
				fontWeight: 'normal',   // "bold" or "normal"
				underline: false        // Underline?
			},

			ARROW_DEFAULTS: {
				length: 100,            // Length of the arrow's body
				size: 30,               // Width/Height of the arrow's head
				strokeWidth: 10         // Thickness of the arrow's body
			},

			CANVAS_DEFAULTS: {
				width: 640,             // do NOT change
				height: 360             // do NOT change
			}
		}
	},

	methods: {

		createArrow(color, fields) {
			/* Creates and returns a new Fabric group with custom type "arrow" */

			let arrowLength = this.ARROW_DEFAULTS.length
			let arrowSize = this.ARROW_DEFAULTS.size
			let arrowWidth = this.ARROW_DEFAULTS.strokeWidth

			let arrowHead = new fabric.Triangle({
				strokeWidth: 0,
				fill: color,
				width: arrowSize,
				height: arrowSize,
				left: arrowLength + arrowSize,
				top: 0,
				angle: 90
			})

			let arrowBody = new fabric.Line([0, 0, arrowLength, 0], {
				stroke: color,
				strokeWidth: arrowWidth,
				fill: color,
				left: 0,
				top: (arrowHead.height - arrowWidth) / 2
			})

			return new fabric.Group([arrowHead, arrowBody], {
				...fields,
				type: 'arrow'			            // override 'group' as 'arrow'
			})
		}
	}



}